// src/utils/jsonHelper.js
import config from '@/config/config';

export class JSONHelper {
    /**
     * 安全解析包含未转义双引号的JSON字符串
     */
    static safeParse(jsonString) {
        try {
            return JSON.parse(jsonString);
        } catch (e1) {
            try {
                const fixedJSON = this.fixJSONString(jsonString);
                return JSON.parse(fixedJSON);
            } catch (e2) {
                console.error('JSON解析失败:', e2);
                return null;
            }
        }
    }

    /**
     * 修复JSON字符串中的双引号问题
     */
    static fixJSONString(jsonString) {
        return jsonString.replace(/\[\[([^\]]*?)\]\]/g, (match, content) => {
            const backslash = '\\';
            const quote = '"';
            const fixedContent = content.replace(/"/g, backslash + quote);
            return '[[' + fixedContent + ']]';
        });
    }

    /**
     * 解析包含c_goods字段的JSON数据
     */
    static parseGoodsData(jsonString) {
        const result = this.safeParse(jsonString);

        if (result && result.c_goods) {
            try {
                result.c_goods = JSON.parse(result.c_goods);
            } catch (e) {
                console.error('c_goods字段解析失败:', e);
            }
        }

        return result;
    }
}

/**
 * 获取数据的函数
 * @param {string} endpoint - API端点
 * @returns {Promise<Object>} 返回解析后的数据
 */
export async function gamelist(endpoint) {
    try {
        const response = await fetch(`${config.apiBaseUrl}${endpoint}`);
        const result = await response.json();
        return result;
    } catch (error) {
        console.error('数据获取失败:', error);
        throw error;
    }
}
// ... existing code ...
// ... existing code ...
/**
 * 获取数据的函数 - 适配ThinkAdmin框架格式
 * @param {Object} options - 请求配置选项
 * @param {string} options.type - 数据类型 (stditems, monsters, maps, monsterRefresh)
 * @param {number|string} options.id - 可选，数据ID
 * @param {Object} options.extraParams - 可选，额外的查询参数
 * @param {string} options.method - HTTP方法，默认为'GET'
 * @param {number} options.timeout - 请求超时时间
 * @param {boolean} options.withCredentials - 是否携带Cookie
 * @returns {Promise<Object>} 返回解析后的数据
 */
export async function fetchData(options = {}) {
    try {
        const {
            type = 'stditems', // 默认获取物品数据
            id = '', // 默认不指定ID
            extraParams = {},
            method = 'GET',
            timeout = config.timeout,
            withCredentials = true
        } = options;

        // 构建ThinkAdmin框架格式的URL
        // 固定格式：droprate/api.dropratelist/detail
        const baseUrl = `${config.apiBaseUrl}droprate/api.dropratelist/detail`;

        // 构建查询参数
        const params = {
            type,
            ...extraParams
        };

        // 如果提供了ID，则添加到查询参数中
        if (id !== '') {
            params.id = id;
        }

        // 构建完整的URL
        let url = baseUrl;
        if (Object.keys(params).length > 0) {
            const queryString = new URLSearchParams(params).toString();
            url += `?${queryString}`;
        }

        // 构建fetch选项
        const fetchOptions = {
            method,
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: withCredentials ? 'include' : 'omit',
            signal: AbortSignal.timeout(timeout) // 设置超时
        };

        // 添加请求体数据 - 虽然ThinkAdmin主要使用GET，但保留POST支持
        if (options.data && (method === 'POST' || method === 'PUT' || method === 'PATCH')) {
            fetchOptions.body = JSON.stringify(options.data);
        }

        //console.log('请求URL:', url);
        //console.log('请求选项:', fetchOptions);

        const response = await fetch(url, fetchOptions);

        // 检查响应状态
        if (!response.ok) {
            throw new Error(`HTTP错误! 状态码: ${response.status}`);
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error('数据获取失败:', error);
        // 处理超时错误
        if (error.name === 'TimeoutError') {
            throw new Error('请求超时，请检查网络连接');
        }
        throw error;
    }
}
// ... existing code ...
// ... existing code ...

/**
 * 使用示例:
 * 
 * import { JSONHelper, fetchData } from '@/utils/jsonHelper';
 * 
 * export default {
 *     methods: {
 *         async loadData() {
 *             try {
 *                 const result = await fetchData('droprate/api.dropratelist');
 *                 if (result.code === 1) {
 *                     this.apiData = result.data;
 *                 } else {
 *                     this.errorMessage = result.info || '请求失败';
 *                 }
 *             } catch (error) {
 *                 this.errorMessage = '网络请求异常: ' + error.message;
 *             }
 *         },
 *         
 *         handleData() {
 *             const badJSON = '{"c_goods":"[["新人装备",0,null,0]]"}';
 *             const parsedData = JSONHelper.parseGoodsData(badJSON);
 * 
 *             if (parsedData) {
 *                 console.log('解析结果:', parsedData);
 *                 // 处理数据...
 *             }
 *         }
 *     }
 * }
 */